import { createSlice } from "@reduxjs/toolkit";

const dummySlice = createSlice({
  name: "dummy",
  initialState: {
    dummy: false,
  },
  reducers: {
    logIn: (state) => ({ ...state, dummy: !state.dummy }),
    logOut: (state) => ({ ...state, dummy: !state.dummy }),
  },
});

export const { logIn, logOut } = dummySlice.actions;

export default dummySlice.reducer;
